<template>
  <v-container grid-list-md >
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion mb-2" v-html="loadedLessons.instructions_spanish"></p>
      </div>
      <div class="e-ejercicio-ejercicio  pt-2">
        <v-layout  pt-0 column>
          <SubCardFila 
            v-for="(lessson, index) in loadedLessons.options"
            :key="`textSubCard-${index}`"
            :respuesta="lessson"
            />
          <v-flex>
            <v-btn @click="texto" outline color="primary" round large class="my-3">
              <img src="../../../assets/images/practica/outline-text.svg" alt="Lectura" style="height: 20px;margin-top: 2px;margin-right: 5px;">
              VER EL TEXTO COMPLETO
            </v-btn>
            <CardTexto 
            :image="require('@/assets/images/unit/practice/' + loadedTextLessons.imagen)"
            :textKr="loadedTextLessons.large_text_korean"
            :textEs="loadedTextLessons.large_text_spanish"
            />
          </v-flex>
          <v-flex>
            <v-btn
            block
            round
            large
            router-link
            :to="`/practica/intermedio/${idUnidad}/ejercicio/practicaFin`"
            class="elevation-0"
            color="primary">
              COMPROBAR
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SubCardFila from '../../../components/Practica/basica/SubCardFila'
import CardTexto from '../../../components/Practica/Global/CardTexto'
import { storeFirebase } from '../../../store/firebase'

export default {
  name: "practicaFilaThree",
  props: ['idUnidad'],
  data() {
    return {
      respuestas: [
        {
          id: 0,
          text: '마르셀라는 요즘 한국어를 배우고 있어요. 그녀는 년 동안 한국어를 배운 다음에 한국을 여행할 거예요.',
          estado: true
        },
        {
          id: 1,
          text: '마르셀라는 어제 큰 여행 가방을 샀어요. 하지만 여행 가방이 너무 비싸서 그것을 사는 다음에 조금 1후회했어요.',
          estado: false
        },
        {
          id: 2,
          text: '할머니는 마르셀라하고 이야기하고 싶어요. 하지만 그녀는 많이 바빠요.“미안해요, 할머니. 숙제를 한 다음에 같이 이야기해 드릴게요.”',
          estado: false
        }
      ]
    }
  },
  created () {
    this.loadLessons()
  },
  components: {
    SubCardFila,
    CardTexto
  },
  computed: {
    ...mapState({
      ui: state => state.ui
    }),
    loadedTextLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 9)
      return data[0]
    },
    loadedLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 3)
      return data[0]
    }
  },
  methods: {
    ...mapActions('ui', [
      'texto'
    ]),
    loadLessons () {
      const payload = {
        id_unit: Number(this.idUnidad),
        id_practice: 0
      }
      storeFirebase.dispatch("loadPracticeLessons", payload)
    }
  }
}
</script>

